// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2p4iF","resendInfoText":"OnGoingPaymentBox_resendInfoText__1qZi0"};